import React, { useState } from 'react'
import LocationDropdown from './locationDropdown'
import { format, addDays, parse } from 'date-fns'

const Parking = ({ agentCode, location }) => {
  const defaultDate = format(addDays(new Date(), 1), 'yyyy-MM-dd')
  const [isParkingDate, setParkingDate] = useState(defaultDate)
  const [isDepartDate, setDepartDate] = useState(format(addDays(new Date(), 8), 'yyyy-MM-dd'))

  function handleArrivalChange(e) {
    setParkingDate(e.target.value)
    var convertDate = parse(e.target.value, 'yyyy-MM-dd', new Date())
    setDepartDate(format(addDays(convertDate, 8), 'yyyy-MM-dd'))
  }
  function handleDepartChange(e) {
    setDepartDate(e.target.value)
  }

  return (
    <form
      className='relative mx-auto max-w-screen-xl rounded bg-orange-500 p-4 shadow-lg'
      method='get'
      rel='sponsored'
      acceptCharset='UTF-8'
      action='https://trip.holidayextras.co.uk/airportparking/c/availability'>
      <input name='agentgroup' type='hidden' defaultValue='SZ' />
      <input name='channel' type='hidden' defaultValue='I' />
      <input name='agent' type='hidden' defaultValue={agentCode || 'WX372'} />
      <input name='request' type='hidden' defaultValue='1' />
      <input name='profile' type='hidden' defaultValue='p4less' />
      <input name='domain' type='hidden' defaultValue='secure.parking4less.com' />
      <input name='rule_set' type='hidden' defaultValue='parking4less' />
      <input name='lang' type='hidden' defaultValue='en' />
      <input name='product' type='hidden' defaultValue='cp' />
      <input type='hidden' defaultValue='https://www.parking4less.com/' />
      <input id='form_dirty' name='form_dirty' type='hidden' defaultValue='0' />

      <div className='-mt-3 items-end lg:flex'>
        <div className='relative w-full lg:mx-1 lg:w-1/4'>
          <label className='mb-1 mt-3 block font-normal text-white' htmlFor='Location'>
            Flying from
          </label>
          <LocationDropdown location={location} />
          <div className='pointer-events-none absolute bottom-0 right-0 px-2 pb-4 text-gray-700'>
            <svg className='h-4 w-4 fill-current' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
              <path d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z' />
            </svg>
          </div>
        </div>
        <div className={`relative flex w-full items-end lg:mx-1 lg:w-1/4`}>
          <div className='w-2/3'>
            <label className='mb-1 mt-3 block font-normal text-white' htmlFor='ArrivalDate'>
              Parking from
            </label>
            <input
              type='date'
              name='ArrivalDate'
              id='ArrivalDate'
              className='relative block h-12 w-full appearance-none rounded-l-md rounded-r-none border border-transparent bg-white py-3 px-4 text-gray-700 focus:z-10'
              min={defaultDate}
              value={isParkingDate}
              onChange={handleArrivalChange}
            />
          </div>
          <div className='relative w-1/3'>
            <label className='mb-1 mt-3 block font-normal text-white' htmlFor='ArrivalTime'>
              <span className='sr-only'>Arrival Time</span>
            </label>
            <select
              name='ArrivalTime'
              id='ArrivalTime'
              type='text'
              className='block h-12 w-full appearance-none rounded-r-md rounded-l-none border-l border-orange-500 bg-white py-3 px-4 text-gray-700'
              defaultValue='0900'>
              <option value='0030'>00:30</option>
              <option value='0100'>01:00</option>
              <option value='0130'>01:30</option>
              <option value='0200'>02:00</option>
              <option value='0230'>02:30</option>
              <option value='0300'>03:00</option>
              <option value='0330'>03:30</option>
              <option value='0400'>04:00</option>
              <option value='0430'>04:30</option>
              <option value='0500'>05:00</option>
              <option value='0530'>05:30</option>
              <option value='0600'>06:00</option>
              <option value='0630'>06:30</option>
              <option value='0700'>07:00</option>
              <option value='0730'>07:30</option>
              <option value='0800'>08:00</option>
              <option value='0830'>08:30</option>
              <option value='0900'>09:00</option>
              <option value='0930'>09:30</option>
              <option value='1000'>10:00</option>
              <option value='1030'>10:30</option>
              <option value='1100'>11:00</option>
              <option value='1130'>11:30</option>
              <option value='1200'>12:00</option>
              <option value='1230'>12:30</option>
              <option value='1300'>13:00</option>
              <option value='1330'>13:30</option>
              <option value='1400'>14:00</option>
              <option value='1430'>14:30</option>
              <option value='1500'>15:00</option>
              <option value='1530'>15:30</option>
              <option value='1600'>16:00</option>
              <option value='1630'>16:30</option>
              <option value='1700'>17:00</option>
              <option value='1730'>17:30</option>
              <option value='1800'>18:00</option>
              <option value='1830'>18:30</option>
              <option value='1900'>19:00</option>
              <option value='1930'>19:30</option>
              <option value='2000'>20:00</option>
              <option value='2030'>20:30</option>
              <option value='2100'>21:00</option>
              <option value='2130'>21:30</option>
              <option value='2200'>22:00</option>
              <option value='2230'>22:30</option>
              <option value='2300'>23:00</option>
              <option value='2330'>23:30</option>
            </select>
            <div className='pointer-events-none absolute bottom-0 right-0 px-2 pb-4 text-gray-700'>
              <svg className='h-4 w-4 fill-current' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
                <path d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z' />
              </svg>
            </div>
          </div>
        </div>
        <div className={`relative flex w-full items-end lg:mx-1 lg:w-1/4`}>
          <div className='w-2/3'>
            <label className='mb-1 mt-3 block font-normal text-white' htmlFor='DepartDate'>
              Returning to collect car
            </label>
            <input
              type='date'
              name='DepartDate'
              id='DepartDate'
              className='relative block h-12 w-full appearance-none rounded-l-md border border-transparent bg-white py-3 px-4 text-gray-700 focus:z-10'
              min={isParkingDate}
              //defaultValue={isDepartDate}
              value={isDepartDate}
              onChange={handleDepartChange}
            />
          </div>
          <div className='relative w-1/3'>
            <label className='mb-1 mt-3 block font-normal text-white' htmlFor='DepartTime'>
              <span className='sr-only'>Return time</span>
            </label>
            <select
              name='DepartTime'
              id='DepartTime'
              type='text'
              className='block h-12 w-full appearance-none rounded-r-md rounded-l-none border-l border-orange-500 bg-white py-3 px-4 text-gray-700'
              defaultValue='0930'>
              <option value='0030'>00:30</option>
              <option value='0100'>01:00</option>
              <option value='0130'>01:30</option>
              <option value='0200'>02:00</option>
              <option value='0230'>02:30</option>
              <option value='0300'>03:00</option>
              <option value='0330'>03:30</option>
              <option value='0400'>04:00</option>
              <option value='0430'>04:30</option>
              <option value='0500'>05:00</option>
              <option value='0530'>05:30</option>
              <option value='0600'>06:00</option>
              <option value='0630'>06:30</option>
              <option value='0700'>07:00</option>
              <option value='0730'>07:30</option>
              <option value='0800'>08:00</option>
              <option value='0830'>08:30</option>
              <option value='0900'>09:00</option>
              <option value='0930'>09:30</option>
              <option value='1000'>10:00</option>
              <option value='1030'>10:30</option>
              <option value='1100'>11:00</option>
              <option value='1130'>11:30</option>
              <option value='1200'>12:00</option>
              <option value='1230'>12:30</option>
              <option value='1300'>13:00</option>
              <option value='1330'>13:30</option>
              <option value='1400'>14:00</option>
              <option value='1430'>14:30</option>
              <option value='1500'>15:00</option>
              <option value='1530'>15:30</option>
              <option value='1600'>16:00</option>
              <option value='1630'>16:30</option>
              <option value='1700'>17:00</option>
              <option value='1730'>17:30</option>
              <option value='1800'>18:00</option>
              <option value='1830'>18:30</option>
              <option value='1900'>19:00</option>
              <option value='1930'>19:30</option>
              <option value='2000'>20:00</option>
              <option value='2030'>20:30</option>
              <option value='2100'>21:00</option>
              <option value='2130'>21:30</option>
              <option value='2200'>22:00</option>
              <option value='2230'>22:30</option>
              <option value='2300'>23:00</option>
              <option value='2330'>23:30</option>
            </select>
            <div className='pointer-events-none absolute bottom-0 right-0 px-2 pb-4 text-gray-700'>
              <svg className='h-4 w-4 fill-current' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
                <path d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z' />
              </svg>
            </div>
          </div>
        </div>
        <div className='relative w-full lg:mx-1 lg:w-1/4'>
          <button href='#' className='button mt-3 h-12 w-full'>
            Search
          </button>
        </div>
      </div>
    </form>
  )
}

export default React.memo(Parking)
